/** @format */

import { fetchAddressFromLatLng } from "core-lib/services/fetchAddressFromLatLng";
import useReverseGeoCode from "core-lib/services/useReverseGeoCode";
import { AddressStatusType } from "core-lib/types/Address";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateLocation } from "../store";
import {
  UserGeoAddressType,
  UserLocationRequestType,
  UserLocationRequirementType,
  UserLocationType,
} from "core-lib/types/Location";
import { updateLocationRequest } from "core-lib/reduxStore/layout/action";

export const useTestDriveLocation = (
  locationBottomSheet = {
    title: "Location Permission needed",
    subtitle:
      "Find the nearest car dealerships and get the best offers for your new car",
  }
) => {
  const dispatch = useDispatch();
  const locObj = {
    requestType: UserLocationRequestType.RequestLatLng,
    payload: {
      locationType: UserLocationType.Current,
      geoAddressType: UserGeoAddressType.Current,
      locationRequirementType:
        UserLocationRequirementType.LocationShowOneTimeBottomSheet,
    },

    bottomsheetData: {
      title: locationBottomSheet?.title,
      subtitle: locationBottomSheet?.subtitle,
    },
  };

  const { fetch, address: nativeAddress } = useReverseGeoCode({
    addressValidation: ["latitude", "longitude"],
    locationV2RequestPayload: locObj,
  });
  const address = useSelector((state: any) => state?.testDrive?.address);

  const handleAddress = async () => {
    dispatch(
      updateLocation({
        data: null,
        status: AddressStatusType.Pending,
      })
    );
    const { locationData, error } = await fetchAddressFromLatLng({
      lat: nativeAddress?.data?.latitude,
      lng: nativeAddress?.data?.longitude,
      radius: 100,
    });
    if (locationData?.city) {
      dispatch(
        updateLocation({
          ...nativeAddress,
          data: {
            ...nativeAddress?.data,
            city: locationData?.city,
            infraCity: locationData?.infraCity
              ? locationData?.infraCity
              : locationData?.city,
            zoneName: locationData?.zoneName
              ? locationData?.zoneName
              : locationData?.city,
            stateId: locationData?.stateId,
            state: locationData?.state,
          },
          status: AddressStatusType.Success,
        })
      );
    } else {
      dispatch(
        updateLocation({
          data: null,
          status: AddressStatusType.Failed,
        })
      );
    }
  };

  const handleNoAddress = () => {
    if (
      [AddressStatusType.Pending].includes(nativeAddress?.status) &&
      [AddressStatusType.Default].includes(address)
    ) {
      dispatch(updateLocation({ status: nativeAddress?.status, data: null }));
    } else if (
      [AddressStatusType.Pending, AddressStatusType.Default].includes(
        address?.status
      ) &&
      [AddressStatusType.Failed, AddressStatusType.Denied].includes(
        nativeAddress?.status
      )
    ) {
      dispatch(updateLocation({ status: nativeAddress?.status, data: null }));
    }
  };

  useEffect(() => {
    if ([AddressStatusType.Default].includes(address?.status)) {
      fetch();
    }
  }, [address]);

  useEffect(() => {
    if (![AddressStatusType.Default].includes(nativeAddress?.status)) {
      if (
        [AddressStatusType.Success].includes(nativeAddress?.status) &&
        !address?.data
      ) {
        handleAddress();
      } else {
        handleNoAddress();
      }
    }
  }, [nativeAddress]);

  return {
    address,
  };
};
